import React from 'react';
import { GearSvgIcon } from '../../GearSvgIcon';
import { useGlobalizationContext } from '../../../context/globalization/GlobalizationContext';
import { useTranslation } from '../../../context/globalization/useTranslation';

const ClearFiltersButton: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const clearAllFieldsFilters = () => {
    window.location.reload();
  };

  return (
    <div
      className={`chipsButtonLink`}
      title={translate('custom.toolbar.filterTagsClear')}
      onClick={clearAllFieldsFilters}
    >
      <GearSvgIcon customIcon="clearFilterIcon" className={`gearIcon`} />
    </div>
  );
};

export default ClearFiltersButton;